<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number], required: true },
  note: { type: String, default: '' },
  icon: { type: String, default: '' },
  tone: {
    type: String,
    default: 'neutral',
    validator: value =>
      ['neutral', 'brand', 'success', 'warning', 'danger'].includes(value),
  },
});

const toneClasses = computed(
  () =>
    ({
      neutral: 'bg-n-slate-3 text-n-slate-11',
      brand: 'bg-teletel-accent-soft text-teletel-accent',
      success: 'bg-n-teal-3 text-n-teal-11',
      warning: 'bg-n-amber-3 text-n-amber-11',
      danger: 'bg-n-ruby-3 text-n-ruby-11',
    })[props.tone]
);
</script>

<template>
  <article
    class="flex min-h-32 flex-col rounded-2xl border border-n-weak bg-teletel-panel p-4 shadow-[var(--teletel-shadow-card)] transition-transform duration-200 hover:-translate-y-0.5"
  >
    <div class="flex items-start justify-between gap-3">
      <span class="text-xs font-medium text-n-slate-11">{{ label }}</span>
      <span
        v-if="icon"
        class="grid size-8 flex-shrink-0 place-content-center rounded-xl"
        :class="toneClasses"
      >
        <span class="size-4" :class="icon" />
      </span>
    </div>
    <strong
      class="mt-3 text-2xl font-semibold tracking-tight text-n-slate-12"
      >{{ value }}</strong
    >
    <span v-if="note" class="mt-auto pt-2 text-xs text-n-slate-10">{{
      note
    }}</span>
  </article>
</template>
